const OpsCartStorage = require("../vault/OpsCartStorage");
const OpsCartAPI = require("../vault/OpsCartAPI");
const ErrorUtil = require("../../../shared/ErrorUtil");

// Cart error checking, based on the table in this doc:
// https://docs.google.com/document/d/1pOS23WUqGe20J3wtcUQWMPV3_xV8R1cCGqOJZvCIPi8/edit

const getCartErrorSituation = function(cart, storage, now) {
	if (!cart) {
		return null;
	} else if (cart.isPlacingOrder) {
		return "isPlacingOrder";
	} else if (cart.isPreparingOrder) {
		return "isPreparingOrder";
	} else if (!OpsCartStorage.checkStorageSync(cart, storage)) {
		return "cartSync";
	}
	return null;
};

// Checks to make before making a change to cart items.
// Returns {cart, step, allowAction: true|false}.
const forItemsChange = function(cart, action, storage, emitEvent, now) {
	const error = getCartErrorSituation(cart, storage, now);
	let allowAction = true;
	if (error === "isPlacingOrder" || error === "isPreparingOrder") {
		ErrorUtil.log(
			"E_CART_CHANGE_DURING_ORDER",
			"Cart items updated while a checkout endpoint was running",
			{endpoint: error, action}
		);
		emitEvent("orderInProgress");
		allowAction = false;
	} else if (error === "cartSync") {
		cart = OpsCartStorage.syncWithStorage(cart, storage);
		// Leave allowAction as true.
	}
	return {cart, step: null, allowAction};
};

// Checks to make before making a change to cart checkout data.
// Returns {cart, step, allowAction: true|false}.
const forCheckoutFormChange = function(cart, action, storage, emitEvent, now) {
	const error = getCartErrorSituation(cart, storage, now);
	let step = null;
	let allowAction = true;
	if (error === "isPlacingOrder") {
		ErrorUtil.log(
			"E_CART_CHANGE_DURING_ORDER",
			"Cart checkout form updated while a checkout endpoint was running",
			{endpoint: error, action}
		);
		// Silently deny change
		allowAction = false;
	} else if (error === "isPreparingOrder") {
		// Silently deny change
		allowAction = false;
	} else if (error === "cartSync") {
		emitEvent("mustRedoCheckout");
		step = "cart";
		cart = OpsCartStorage.syncWithStorage(cart, storage);
		// Leave allowAction as true.
	}
	return {cart, step, allowAction};
};

// Checks to make before starting a checkout endpoint.
// Returns {cart, step, allowAction: true|false}.
const forCheckoutEndpoints = function(cart, action, storage, emitEvent, now) {
	const error = getCartErrorSituation(cart, storage, now);
	let step = null;
	let allowAction = true;
	if (error === "isPlacingOrder" || error === "isPreparingOrder") {
		ErrorUtil.log(
			"E_SENT_SECOND_ORDER",
			"Requested checkout endpoint while another one was running",
			{endpoint: error, action}
		);
		emitEvent("orderInProgress");
		allowAction = false;
	} else if (error === "cartSync") {
		emitEvent("mustRedoCheckout");
		step = "cart";
		cart = OpsCartStorage.syncWithStorage(cart, storage);
		allowAction = false;
	}
	return {cart, step, allowAction};
};

// Checks to make before starting a checkout endpoint.
// Returns {cart, step, allowAction: true|false}.
const forStorageUpdate = function(cart, action, storage, emitEvent, now) {
	const error = getCartErrorSituation(cart, storage, now);
	let step = null;
	let allowAction = true;
	if (error === "isPlacingOrder") {
		ErrorUtil.log(
			"E_STORAGE_CHANGE_DURING_ORDER",
			"Cart updated in storage while a checkout endpoint was running",
			{endpoint: error, action}
		);
		// TODO: This setTimeout is untestable and impure.
		setTimeout(() => OpsCartStorage.saveToStorage(cart, storage), 500);
		allowAction = false;
	} else if (error === "isPreparingOrder") {
		ErrorUtil.log(
			"E_STORAGE_CHANGE_DURING_ORDER",
			"Cart updated in storage while a checkout endpoint was running",
			{endpoint: error, action}
		);
		emitEvent("mustRedoCheckout");
		step = "cart";
		cart = OpsCartAPI.cancelPrepareOrder(cart, now);
	} else if (error === "cartSync") {
		emitEvent("mustRedoCheckout");
		step = "cart";
	}
	return {cart, step, allowAction};
};

module.exports = {
	forItemsChange,
	forCheckoutFormChange,
	forCheckoutEndpoints,
	forStorageUpdate,
};
